import React, { Component } from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import PropTypes from 'prop-types';

import { reduxForm } from 'redux-form';

import { withStyles } from 'material-ui/styles';

import Layout from '../components/Layout';

import login from '../actions/login';
import completeRegistration from '../actions/completeRegistration';
import verifyUser from '../actions/verifyUser';
import forgotPassword from '../actions/forgotPassword';
import confirmPassword from '../actions/confirmPassword';
import resendVerificationCode from '../actions/resendVerification';

import RenderDialog from '../helpers/RenderDialog';
import validationHelper from '../helpers/ValidationHelper';
import UsernamePassword from '../components/User/UsernamePassword';
import VerifyUser from '../components/User/VerifyUser';
import ForgotPassword from '../components/User/ForgotPassword';
import ForgotPasswordReset from '../components/User/ForgotPasswordReset';
import PasswordForm from '../containers/PasswordForm';
import autotecStyle from '../components/Styles/style';

const validate = (values) => {
  const errors = validationHelper.validateRequired(['username', 'password'], values);
  return errors;
};


class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      openDialog: false,
      showResetPasswordConfirmation: false,
      resetPasswordConfirmationMessage: null,
      loginError: null,
      goto: 'home',
      passwordChange: null
    };
  }

  completeRegistration = (userInfo) => {
    this.props.actions.completeRegistration(userInfo, this.props.data.config, this);
  }

  forgotPassword(username) {
    this.props.actions.forgotPassword(username, this.props.data.config, this);
  }

  forgotPasswordReset(username, token, password) {
    this.props.actions.forgotPasswordReset(username, token, password, this.props.data.config, this);
  }

  login(username, password) {
    this.setState({ username });
    this.props.actions.login(username, password, this.props.data.config, this);
  }

  verifyUser(username, token) {
    this.props.actions.verifyUser(username, token, this.props.data.config, this);
  }

  openSupportDialog = (event) => {
    this.setState({ openDialog: true });
  }

  handleClose = (value) => {
    this.setState({ openDialog: false, loginError: null });
  };

  handleChangePassword = (event) => {
    const { passwordChange } = this.state;
    // api does not allow to set this flag
    delete passwordChange.userAttributes.email_verified;
    delete passwordChange.userAttributes.phone_number_verified;

    const self = this;
    passwordChange.cognitoUser.completeNewPasswordChallenge(event.newPassword, passwordChange.userAttributes, {
      onSuccess(result) {
        self.setState({ loginError: null, goto: 'home', showResetPasswordConfirmation: false, resetPasswordConfirmationMessage: null });
      },
      onFailure(err) {
        self.setState({ loginError: err.message });
      }
    });
  }

  showForgotPasswordDialog = (event) => {
    this.setState({ goto: 'forgotPassword' });
  }

  showLoginDialog = (event) => {
    this.setState({ goto: 'home' });
  }

  closeResetPasswordDialog = () => {
    this.setState({ showResetPasswordConfirmation: false, goto: 'forgotPasswordReset', resetPasswordConfirmationMessage: null });
  }

  resendVerificationCode = (username) => {
    this.props.actions.resendVerificationCode(username, this.props.data.config, this);
  }

  render() {
    const { classes } = this.props;
    const { goto, loginError, showResetPasswordConfirmation, resetPasswordConfirmationMessage } = this.state;

    let loginProgress = <div />;
    let errorDialog = <div />;
    let dialog = <div />;

    if (showResetPasswordConfirmation) {
      const message = `Your verification code was sent by ${resetPasswordConfirmationMessage.AttributeName} to ${resetPasswordConfirmationMessage.Destination}`;
      dialog =
        (<RenderDialog
          open
          confirmButton
          message={message}
          onClose={this.closeResetPasswordDialog}
        />);
    }
    if (goto === 'home') {
      loginProgress =
        (<UsernamePassword
          showForgotPasswordDialog={e => this.showForgotPasswordDialog(e)}
          openSupportDialog={e => this.openSupportDialog(e)}
          login={(username, password) => this.login(username, password)}
        />);
    } else if (goto === 'forgotPassword') {
      loginProgress =
        (<ForgotPassword
          forgotPassword={username => this.forgotPassword(username)}
          showLoginDialog={e => this.showLoginDialog(e)}
        />);
    } else if (goto === 'verify') {
      loginProgress =
        (<VerifyUser
          username={this.state.username}
          verifyUser={(username, token) => this.verifyUser(username, token)}
          resendVerificationCode={username => this.resendVerificationCode(username)}
        />);
    } else if (goto === 'forgotPasswordReset') {
      loginProgress =
        (<ForgotPasswordReset
          username={this.state.username}
          forgotPasswordReset={(username, token, password) => this.forgotPasswordReset(username, token, password)}
          showLoginDialog={e => this.showLoginDialog(e)}
        />);
    } else if (goto === 'newPassword') {
      loginProgress = <PasswordForm title="New password required" oldPasswordNotRequired handleSave={e => this.handleChangePassword(e)} />;
    }

    if (loginError) {
      const { message } = loginError;
      let messageVal;
      // translate error messages
      switch (loginError.code) {
        case 'InvalidParameterException':
          if (message.includes('Cannot reset password for the user as there is no registered/verified email or phone_number')) {
            messageVal = 'There is a problem with your login.  Please contact Customer Service for further assistance.';
            break;
          }
          messageVal = 'Invalid character in input.  Please check and try again.';
          break;
        case 'UserNotFoundException':
          messageVal = 'Incorrect username or password.';
          break;
        default:
          messageVal = message;
          break;
      }

      errorDialog =
        (<RenderDialog
          open
          confirmButton
          message={messageVal}
          onClose={this.handleClose}
        />);
    }

    return (
      <Layout className="App" showHeader={false} menuTitle="Login" toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727.">
        <div className="Home">
          <Paper
            style={{
              width: '429px',
              height: '550px',
              borderRadius: 7,
              boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
            }}>
            <div style={{ paddingTop: '44px' }} />
            <img
              src="logo.png"
              width="175"
              height="110"
              alt=""
              style={{
                WebkitFilter: 'drop-shadow(0px 2px 2px rgba(0,0,0,0.25)',
              }}
            />
            {dialog}
            {errorDialog}
            {loginProgress}
            <RenderDialog
              open={this.state.openDialog}
              title=""
              message="Please contact our Customer Service department at (205) 414-2727."
              onClose={this.handleClose}
              className={classes.alertClass}
            />
          </Paper>
        </div>
      </Layout>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.shape().isRequired
};

const mapStateToProps = state => ({
  data: {
    config: state.config.config
  }
});

const mapDispatchToProps = dispatch => ({
  actions: {
    login: (username, password, config, self) => {
      dispatch(login(username, password, config))
        .then((response) => {
          // good login
        })
        .catch((error) => {
          if (error.code === 'UserNotConfirmedException') {
            self.setState({ goto: 'verify', username, loginError: null });
          } else if (error.code === 'NEW_PASSWORD_REQUIRED') {
            self.setState({ goto: 'newPassword', username, loginError: null, passwordChange: error });
            console.log(error);
          } else {
            self.setState({ loginError: error });
          }
        });
    },
    completeRegistration: (userInfo, config, self) => {
      dispatch(completeRegistration(userInfo, config))
        .then((o) => {
          self.setState({ goto: 'home' });
        })
        .catch((error) => {
          self.setState({ loginError: error });
        });
    },
    verifyUser: (username, token, config, self) => {
      dispatch(verifyUser(username, token, config))
        .then((o) => {
          self.setState({ goto: 'home', loginError: { message: 'Your account has been successfully verified. Please re-enter your username and password to log into the system.' } });
        })
        .catch((error) => {
          console.log(error);
          self.setState({ loginError: error });
        });
    },
    resendVerificationCode: (username, config, self) => {
      dispatch(resendVerificationCode(username, config))
        .then((o) => {
          self.setState({ goto: 'verify', loginError: { message: 'Verification code sent successfully' } });
        })
        .catch((error) => {
          console.log(error);
          self.setState({ loginError: error });
        });
    },
    forgotPasswordReset: (username, token, password, config, self) => {
      dispatch(confirmPassword(username, token, password, config))
        .then((o) => {
          self.setState({ username, loginError: null, goto: 'home', showResetPasswordConfirmation: false, resetPasswordConfirmationMessage: null });
        })
        .catch((error) => {
          self.setState({ loginError: error });
        });
    },
    forgotPassword: (username, config, self) => {
      dispatch(forgotPassword(username, config))
        .then((o) => {
          self.setState({ username, goto: null, showResetPasswordConfirmation: true, resetPasswordConfirmationMessage: o.value.CodeDeliveryDetails });
        })
        .catch((error) => {
          self.setState({ loginError: error });
        });
    }
  }
});

const ConnectedLogin = connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);

export default withStyles(autotecStyle, { withTheme: true })(reduxForm({
  form: 'ConnectedLoginForm',
  validate
})(ConnectedLogin));


// WEBPACK FOOTER //
// ./src/containers/Login.js